import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subject, Observable } from 'rxjs';
import { Acquisition } from 'src/app/_models/acquisition';
import { HttpClient } from '@angular/common/http';
import { AcquisitionView } from 'src/app/_models/acquisitionView';
import { AcquisitionResidual } from 'src/app/_models/acquisitionResidual';
import { AcquisitionCorrection } from 'src/app/_models/acquisitionCorrection';
import { Asset } from 'src/app/_models/asset';

@Injectable({
  providedIn: 'root'
})
export class AcquisitionService {
  baseUrl = environment.apiUrl;
  ImportSelected = new Subject<Acquisition>();
  acquisitionSelected = new Subject<Acquisition>();
  leaseAcquisitionSelected = new Subject<Acquisition>();
  constructor(private http: HttpClient) { }

  changeEditState(a: Acquisition) {
    this.acquisitionSelected.next(a);
  }

  changeLeaseAcquisitionEditState(aq: Acquisition) {
    this.leaseAcquisitionSelected.next(aq);
  }


  changeImportState(acquisition: Acquisition) {
    this.ImportSelected.next(acquisition);
  }
  getAcquisitionByAssetCode(assetCode): Observable<Acquisition> {
    return this.http.get<Acquisition>(this.baseUrl + 'acquisition/assetcode/' + assetCode);
  }
  getAcquisition(id): Observable<Acquisition> {
    return this.http.get<Acquisition>(this.baseUrl + 'acquisition/' + id);
  }
  getAcquisitionView(id): Observable<AcquisitionView> {
    return this.http.get<AcquisitionView>(this.baseUrl + 'acquisition/view/' + id);
  }
  getAcquisitionViewByJournalRef(id): Observable<AcquisitionView> {
    return this.http.get<AcquisitionView>(this.baseUrl + 'acquisition/view/journalref/' + id);
  }
  getAcquisitionCorrection(id): Observable<AcquisitionCorrection> {
    return this.http.get<AcquisitionCorrection>(this.baseUrl + 'acquisition/correction/' + id);
  }
  getAcquisitionCorrectionJournalRef(id): Observable<AcquisitionCorrection> {
    return this.http.get<AcquisitionCorrection>(this.baseUrl + 'acquisition/correction/journalref/' + id);
  }
  getAcquisitionResidual(barcode): Observable<AcquisitionResidual> {
    return this.http.get<AcquisitionResidual>(this.baseUrl + 'acquisition/residual/' + encodeURIComponent(barcode));
  }

  createAcquisition(acquisition: Acquisition) {
    return this.http.post(this.baseUrl + 'acquisition', acquisition);
  }
  updateAcquisition(id: number, acquisition: Acquisition) {
    return this.http.put(this.baseUrl + 'acquisition/' + id, acquisition);
  }
  cancelAcquisition(id: number) {
    return this.http.delete(this.baseUrl + 'acquisition/cancel/' + id);
  }

  export(): Observable<Blob> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.baseUrl + 'acquisition/export', {
      responseType: 'blob'
    });
  }
  exportCorrections(): Observable<Blob> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(this.baseUrl + 'acquisition/exportcorrections', {
      responseType: 'blob'
    });
  }

  getHasWorkflow(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + 'acquisition/hasWorkflow');
  }
}
